//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Carotid_Artery_Stenosis',
  data () {
    return {
      form: {
        data1: '',
        data2: ''
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        if (form.data1 == 0) {
          return '...'
        }
        console.log(form)
        let Katz = (1 - (form.data2 / form.data1)) * 100
        self.hasScore = true
        return Katz.toFixed(2)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/Carotid_Artery_Stenosis.vue